
import React, { useState } from "react";
import './WebDesign.css';
import designteam from './assets/designteam.jpg';
import WebDevelopment from './assets/WebDevelopment.jpg';
import MobileOptimization from './assets/MobileOptimization.jpg';
import WebProcess from './assets/WebProcess.jpg';
import consulting from './assets/consulting.png';

const WebDesign = () => {


    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Web Design</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Web Design</span>
                        </p>
                    </div>
                </div>
            </section>

            {/* second Section */}
            <div className="company-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src={designteam} alt="About Us" className="img-fluid about-image" />
                        </div>
                        <div className="col-md-6 text-column">
                            <h2>Web Design Your Brand Deserves</h2>
                            <h3>Why a Professional Website Matters</h3>
                            <p>Your website is often the first interaction potential customers have with your brand. A well-designed, high-performing site can:</p>
                            <ul>
                                <li>Increase credibility and brand trust.</li>
                                <li>Improve customer engagement and retention.</li>
                                <li>Enhance user experience and ease of navigation.</li>
                                <li>Boost sales conversions and lead generation.</li>
                                <li>Improve search engine rankings through optimized performance.</li>
                                <li>Provide seamless access across multiple devices.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* thired Section */}
            <div className="web-design container">
                <section className="hero-section">
                    <h1>Web Design & Development</h1>
                    <p>Building the Digital Experience Your Brand Deserves</p>
                </section>

                <div className="container">
                    <div className="row">
                        <div className="col-md-6 py-5">
                            <div className="content-section">
                                <h2>Our Web Design & Development Process</h2>
                                <ol>
                                    <li><b>Discovery & Strategy</b></li>
                                    <p>We begin by understanding your business, target audience, and objectives. This allows us to create a customized strategy that aligns with your goals.</p>
                                    <li><b>Wireframing & Design</b></li>
                                    <p>Our designers craft wireframes and prototypes to map out the structure and user experience before proceeding to the final designs.</p>
                                    <li><b>Development & Coding</b></li>
                                    <p>We use cutting-edge technologies and best coding practices to develop a robust and high-performing website tailored to your needs.</p>
                                    <li><b>Testing & Quality Assurance</b></li>
                                    <p>Before launch, we perform rigorous testing to ensure smooth functionality, fast loading speeds, and a flawless user experience across all devices.</p>
                                    <li><b>Deployment & Ongoing Support</b></li>
                                    <p>Once your site is live, we provide continuous support, updates, and maintenance to ensure long-term success.</p>
                                </ol>
                            </div>
                        </div>
                        <div className="col-md-6 side-images py-5">
                            <img src={WebDevelopment} alt="Web Development" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={MobileOptimization} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section">
                                <h3>Advanced Features We Provide</h3>
                                <ul>
                                    <li><strong>SEO-Friendly Design:</strong> Optimized for search engines to improve visibility and rankings.</li>
                                    <li><strong>Security Enhancements:</strong> Protection against cyber threats and data breaches.</li>
                                    <li><strong>Fast Load Times:</strong> Performance-optimized websites for better user engagement.</li>
                                    <li><strong>Scalability:</strong> Websites built to grow alongside your business.</li>
                                    <li><strong>Integration Capabilities:</strong> Seamlessly integrate third-party tools, APIs, and plugins.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 py-5">
                            <div className="content-section">
                                <h2>Why Choose Dot Localhost?</h2>
                                <ul>
                                    <li><strong>Expertise & Experience:</strong> A team of seasoned designers and developers.</li>
                                    <li><strong>Tailored Solutions:</strong> Custom-built websites that align with your unique needs.</li>
                                    <li><strong>Cutting-Edge Technology:</strong> Use of modern frameworks and industry best practices.</li>
                                    <li><strong>SEO & Performance Optimization:</strong> Designed to rank higher and perform efficiently.</li>
                                    <li><strong>Long-Term Support:</strong> Dedicated assistance even after project completion.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 side-images py-5">
                            <img src={consulting} alt="Mobile Optimization" className="mt-3" />
                        </div>
                    </div>

                    <section className="hero-section mb-5">
                        <p>A strong online presence starts with a well-designed website. At Dot Localhost, we are committed to building high-performance, visually appealing, and results-driven websites. Whether you need a corporate website, an e-commerce store, or a custom-built platform, we have the expertise to make it happen.</p>
                        <p>Contact us today to get started on creating a website that truly represents your brand and delivers an exceptional user experience.</p>
                    </section>

                </div>
            </div>

        </>
    );
};

export default WebDesign;
